import { Component, OnInit } from '@angular/core';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Item, FdSelectConfig } from 'src/app/shared/fd-form-components/fd-select/fd-select.component';
import { MatDialog } from '@angular/material/dialog';
import { ServicesTypeModel } from 'src/app/shared/models/services-type.model';
import { ServicesConfigService } from './services/services-config.service';
import { OptionsServiceComponent } from './components/options-service/options-service.component';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../shared/service/loading.service';
import { HierarchyService } from '../shared/service/hierarchy.service';
import { EditInitialsComponent } from './components/edit-initials/edit-initials.component';

@Component({
    selector: 'app-service-config',
    templateUrl: './service-config.component.html',
    styleUrls: ['./service-config.component.scss'],
    standalone: false
})
export class ServiceConfigComponent implements OnInit {

  private readonly filterAll: Item = {
    label: 'Selecione uma opção',
    value: ''
  };

  private static sortByServiceId(a: ServicesTypeModel, b: ServicesTypeModel): number {
    const serviceIdA = Number(a?.serviceId ?? 0);
    const serviceIdB = Number(b?.serviceId ?? 0);
    return serviceIdA - serviceIdB;
  }

  dataSource = new Array<ServicesTypeModel>();

  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  tableFields: FdFieldConfigs;

  statusList: Item[] = [{
    label: 'Ativo',
    value: true
  },
  {
    label: 'Inativo',
    value: false
  }];


  constructor(
    private formBuilder: UntypedFormBuilder,
    private servicesConfigService: ServicesConfigService,
    private sharedService: HierarchyService,
    private dialog: MatDialog,
    private loadingService: LoadingService,
  ) { }

  ngOnInit() {
    this.startForms();
  }

  edit(data: ServicesTypeModel) {
    const dialogRef = this.dialog.open(OptionsServiceComponent, {
      width: '75%',
      height: '95%',
      data: {
        servicesTypeModel: data
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      setTimeout(() => this.search(), 500);
    });
  }

  editInitials() {
    this.dialog.open(EditInitialsComponent, {
      width: '40%',
      height: '85%',
    });
  }


  // SEARCH
  status() {
    (this.fields.status as FdSelectConfig).items = [];
    (this.fields.status as FdSelectConfig).items.push(...this.statusList);
  }

  selectedServiceContract(): void {
    this.search();
  }

  selectedInstitution(): void {
    this.formGroup.controls.serviceContract.setValue(null);
    this.getServiceContract(this.formGroup.value.institutionNumber);
    this.search();
  }

  search(): void {
    this.loadingService.show();
    if (this.formGroup.value.institutionNumber
      && this.formGroup.value.serviceContract) {
      this.getServiceConfigByServiceContract(
        this.formGroup.value.institutionNumber,
        this.formGroup.value.serviceContract
      );
    } else if (this.formGroup.value.institutionNumber) {
      this.getServiceConfigByInstitution(
        this.formGroup.value.institutionNumber
      );
    }
  }
  // SERVICES

  getInstitutionList(): void {
    this.loadingService.show();

    this.sharedService.institution()
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(list => {
        if (list != null) {
          (this.fields.institutionNumber as FdSelectConfig).items = [];
          (this.fields.institutionNumber as FdSelectConfig).items.push(this.filterAll);
          (this.fields.institutionNumber as FdSelectConfig).items.push(...list);
        }
      });
  }

  getServiceContract(institutionNumber: string): void {

    if (!institutionNumber) {
      institutionNumber = this.formGroup.value.institutionNumber;
    }
    if (institutionNumber) {
      this.sharedService.serviceContractByInstitution(institutionNumber)
        .subscribe(data => {
          if (data) {
            (this.fields.serviceContract as FdSelectConfig).items = [];
            (this.fields.serviceContract as FdSelectConfig).items.push(this.filterAll);
            (this.fields.serviceContract as FdSelectConfig).items.push(...data);
          }
        });
    }
  }

  getServiceId(institutionNumber: string, serviceContract: string): void {
    this.sharedService.serviceid(institutionNumber, serviceContract)
      .subscribe(data => {
        if (data) {
          (this.fields.serviceId as FdSelectConfig).items = [];
          (this.fields.serviceId as FdSelectConfig).items.push(...data);
        }
      });
  }

  getServiceConfigByInstitution(institutionNumber: string) {
    this.servicesConfigService.serviceConfigByInstitution(institutionNumber)
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(list => {
        if (list) {
          this.dataSource = new Array<ServicesTypeModel>();
          this.dataSource = list.sort(ServiceConfigComponent.sortByServiceId)
            .map(value => ({
              serviceId: value.serviceId,
              serviceName: value.serviceName,
              serviceContractId: value.serviceContractId,
              modality: this.checkModality(value.modality),
              tradeName: value.tradeName,
              disclaimer: value.disclaimer,
              institutionId: value.institutionId,
              terminalManufacturerId: value.terminalManufacturerId,
              terminalManufacturerName: value.terminalManufacturerName,
              deviceOnAgency: value.deviceOnAgency,
              isEnabled: value.isEnabled,
              technologyGroup: value.technologyGroup,
              imageDescription: value.imageDescription,
              imageFilename: value.imageFilename,
              isPiloto: value.isPiloto,
              isConfigTechnologyAble: value.isConfigTechnologyAble,
              advantages: value.advantages,
              details: value.details
            }));
            this.loadingService.hide();
        }
      });
  }

  getServiceConfigByServiceContract(institutionNumber: string, serviceContract: string) {
    this.servicesConfigService.serviceConfigList(institutionNumber, serviceContract)
      .subscribe(list => {
        if (list) {
          this.dataSource = new Array<ServicesTypeModel>();
          this.dataSource = list.sort(ServiceConfigComponent.sortByServiceId)
            .map(value => ({
              serviceId: value.serviceId,
              serviceName: value.serviceName,
              serviceContractId: value.serviceContractId,
              modality: this.checkModality(value.modality),
              tradeName: value.tradeName,
              disclaimer: value.disclaimer,
              institutionId: value.institutionId,
              terminalManufacturerId: value.terminalManufacturerId,
              terminalManufacturerName: value.terminalManufacturerName,
              deviceOnAgency: value.deviceOnAgency,
              isEnabled: value.isEnabled,
              technologyGroup: value.technologyGroup,
              imageDescription: value.imageDescription,
              imageFilename: value.imageFilename,
              isConfigTechnologyAble: value.isConfigTechnologyAble,
              advantages: value.advantages,
              details: value.details,
              isPiloto: value.isPiloto,
            }));
            this.loadingService.hide();
        }
      });
  }

  // FORMS

  startForms(): void {

    this.formGroup = this.formBuilder.group({
      institutionNumber: [''],
      serviceContract: ['']
    });

    this.fields = {
      institutionNumber: {
        label: 'Nº Instituição',
        items: [],
        controlName: 'institutionNumber',
        panelWidth: '320px'
      },
      serviceContract: {
        label: 'Service Contract',
        items: [],
        controlName: 'serviceContract',
        panelWidth: '320px'
      }
    };
  }

  checkModality(modality: string): string {
    switch (modality) {
      case 'SALES': {
        return 'Venda';
        break;
      }
      case 'RENT': {
        return 'Aluguel';
        break;
      }
      case 'NEW_LEND': {
        return 'Novo Comodato';
        break;
      }
      default: {
        return '';
        break;
      }
    }
  }

}
